class RadicalCartCount extends HTMLElement {
  connectedCallback() {
    this.countElement = this.querySelector('[data-radical-cart-count]');
    this.actionElement = this.querySelector('[data-radical-cart-action]');

    document.addEventListener('shopify:cart:lines-update', this.handleCartUpdate);
    window.addEventListener('pageshow', this.handlePageShow);
  }

  disconnectedCallback() {
    document.removeEventListener('shopify:cart:lines-update', this.handleCartUpdate);
    window.removeEventListener('pageshow', this.handlePageShow);
  }

  handleCartUpdate = (event) => {
    if (!event.promise) {
      this.refreshCount();
      return;
    }

    event.promise
      .then(() => this.refreshCount())
      .catch(() => this.refreshCount());
  };

  handlePageShow = () => {
    this.refreshCount();
  };

  async refreshCount() {
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
        headers: { Accept: 'application/json' },
      });

      if (!response.ok) return;

      const cart = await response.json();
      this.renderCount(cart.item_count ?? 0);
    } catch (_) {
      // Keep the server-rendered count when the cart endpoint is unavailable.
    }
  }

  renderCount(itemCount) {
    const count = Math.max(0, Number(itemCount) || 0);

    if (this.countElement) this.countElement.textContent = String(count);
    if (this.actionElement) this.actionElement.setAttribute('aria-label', `Carrito, ${count} artículos`);
  }
}

if (!customElements.get('radical-cart-count')) {
  customElements.define('radical-cart-count', RadicalCartCount);
}
